unit App.Version; 

interface

uses
  System.SysUtils;

type
  TAppVersion = record
    Major, Minor, Release, Build: Integer;
    ReleaseTimestamp: TDateTime;

    function VersionString: string;

  end;

var
  AppVersion: TAppVersion;
  DebugVersion: TAppVersion;
  ReleaseVersion: TAppVersion;
  fsLocal: TFormatSettings;

implementation

function TAppVersion.VersionString: string;
begin
  Result := IntToStr(Major) + '.' + IntToStr(Minor) + '.' + IntToStr(Release) + '.' + IntToStr(Build);

end;

initialization
  fsLocal.ShortDateFormat := 'dd/mm/yyyy';
  fsLocal.DateSeparator := '/';
  fsLocal.TimeSeparator := ':';
  fsLocal.LongTimeFormat := 'hh:nn:ss';
  DebugVersion.Major := 1;
  DebugVersion.Minor := 0;
  DebugVersion.Release := 0;
  DebugVersion.Build := 883;

  DebugVersion.ReleaseTimestamp := StrToDateTime('04/08/2026 17:33:32', fsLocal);

  ReleaseVersion.Major := 1;
  ReleaseVersion.Minor := 0;
  ReleaseVersion.Release := 0;
  ReleaseVersion.Build := 50;
  ReleaseVersion.ReleaseTimestamp := StrToDateTime('27/05/2026 15:01:39', fsLocal);

  {$IFDEF DEBUG}
  AppVersion := DebugVersion;
  {$ELSE}
  AppVersion := ReleaseVersion;
  {$ENDIF}

end. 
